import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { ApiResponseStatusEnum } from "../ApiResponseStatusEnum";

const ENDPOINT = "/device/model_list";

export class GetAvailableMachineModelsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand();
        var response = new ApiGenericResponse(res);
        if (response.responseStatus == ApiResponseStatusEnum.Success) {
            if (res.data && res.data.Payload && res.data.Payload.Models) response.payload = res.data.Payload.Models;
        }
        return response;
    }
}
